const Pzn = {
  /**
   *
   * @param {String} scannedBarcode
   * @return {boolean}
   */
  validatePzn(scannedBarcode) {
    return !!Pzn.getPzn(scannedBarcode);
  },

  getPzn(scannedBarcode) {
    return Pzn.getPznFromCode39(scannedBarcode) || Pzn.getPznFromDatamatrix(scannedBarcode);
  },

  /**
   * @private
   * @param pzn
   * @return {boolean}
   */
  validatePznCheckdigit(pzn) {
    const pznParts = [...pzn];

    let sum = 0;

    for (let i = 0; i < pznParts.length - 1; i++) {
      sum += Number.parseInt(pznParts[i]) * (i + 1);
    }

    return Number.parseInt(pznParts.at(-1)) === sum % 11;
  },

  /**
   * @private
   * @param scannedCode39
   * @return {*|null}
   */
  getPznFromCode39(scannedCode39) {
    const regex = new RegExp(String.raw`-\d{7,8}`, "g");

    if (!regex.test(scannedCode39)) {
      return null;
    }

    let pzn = scannedCode39.replace("-", "");

    if (pzn.length === 7) {
      pzn = `0${pzn}`;
    }

    if (!Pzn.validatePznCheckdigit(pzn)) {
      return null;
    }

    return scannedCode39.replace("-", "");
  },

  /**
   * @private
   * @param scannedCode39
   * @return {boolean}
   */
  validateCode39Pzn(scannedCode39) {
    return !!Pzn.getPznFromCode39(scannedCode39);
  },

  validateNtin(ntin) {
    const ntinParts = [...ntin];

    let sum = 0;

    for (let i = 0; i < ntinParts.length - 1; i++) {
      sum += Number.parseInt(ntinParts[i]) * (i === 0 || i % 2 === 0 ? 3 : 1);
    }

    const nextTen = Math.ceil(sum / 10) * 10;

    return Number.parseInt(ntinParts.at(-1)) === nextTen - sum;
  },

  /**
   *
   * @param {String} scannedDatamatrix
   */
  getPznFromGs1(scannedDatamatrix) {
    const regex = new RegExp(String.raw`04150\d{9}`, "g");
    const results = regex.exec(scannedDatamatrix);

    if (results?.length !== 1) {
      return null;
    } else if (!Pzn.validateNtin(results[0])) {
      return null;
    }

    const pzn = results[0].slice(5, -1);

    if (!Pzn.validatePznCheckdigit(pzn)) {
      return null;
    } else {
      return pzn;
    }
  },

  validatePpn(ppn) {
    const ntinParts = [...ppn];

    let sum = 0;

    for (let i = 0; i < ntinParts.length - 2; i++) {
      sum += ntinParts[i].codePointAt(0) * (i + 2);
    }

    return Number.parseInt(`${ntinParts.at(-2)}${ntinParts.at(-1)}`) === sum % 97;
  },

  getPznFromAsc(scannedDatamatrix) {
    const regex = new RegExp(String.raw`11\d{10}`, "g");
    const results = regex.exec(scannedDatamatrix);

    if (results?.length !== 1) {
      return null;
    } else if (!Pzn.validatePpn(results[0])) {
      return null;
    }

    const pzn = results[0].slice(2, -2);

    if (!Pzn.validatePznCheckdigit(pzn)) {
      return null;
    } else {
      return pzn;
    }
  },

  /**
   * @private
   * @param scannedDatamatrix
   */
  getPznFromDatamatrix(scannedDatamatrix) {
    return Pzn.getPznFromGs1(scannedDatamatrix) || Pzn.getPznFromAsc(scannedDatamatrix);
  },

  /**
   * @private
   * @param scannedDatamatrix
   * @return {boolean}
   */
  validateDatamatrixPzn(scannedDatamatrix) {
    return !!Pzn.getPznFromDatamatrix(scannedDatamatrix);
  },
};

export default Pzn;
